export default "__VITE_ASSET__y3_pcpI2__"